// Eine Grenze für die ganze Oberfläche.
//
// Unterhalb davon gilt die App-Ansicht: Kachelbrett, Tableiste, Seitenstapel
// mit Wisch-zurück. Oberhalb bleibt alles wie am Schreibtisch.
//
// Der Wert ist bewusst `lg` von Tailwind und nicht 768 px: Layout.tsx schaltet
// dort seit jeher zwischen Burger und Seitenleiste um. Eine zweite Grenze
// ergäbe dazwischen ein Niemandsland mit der alten Burger-Ansicht.
//
// Die Umschaltung hängt an der Breite, NICHT an istNativ(). Wer lagerpro.app
// am Telefon im Browser öffnet, soll dieselbe Bedienung bekommen.
import { useEffect, useState } from 'react';

export const SCHMAL_ABFRAGE = '(max-width: 1023.98px)';

function jetztSchmal(): boolean {
  // Im Testlauf und beim Rendern auf dem Server gibt es kein window.
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(SCHMAL_ABFRAGE).matches;
}

/**
 * Ist der Bildschirm schmal genug für die App-Ansicht?
 *
 * Reagiert auf Größenänderungen, ohne dass die Seite neu geladen wird — das
 * Drehen eines Tablets und das Ziehen eines Fensters sind derselbe Fall.
 */
export function useSchmal(): boolean {
  const [schmal, setSchmal] = useState(jetztSchmal);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(SCHMAL_ABFRAGE);
    const beiWechsel = (e: MediaQueryListEvent) => setSchmal(e.matches);
    // Beim Einhängen noch einmal angleichen: zwischen erstem Rendern und
    // diesem Zeitpunkt kann sich die Breite geändert haben.
    setSchmal(mq.matches);
    mq.addEventListener('change', beiWechsel);
    return () => mq.removeEventListener('change', beiWechsel);
  }, []);

  return schmal;
}
